import * as React from 'react';
import * as Yup from 'yup';
import { Field, Formik, FieldProps, FormikProps } from 'formik';
import { StyledForm, FieldRow, StyledFormGroup, Card, Button, StyledFormSelect } from '../../components';
import { formatGqlError } from '../../utils/helpers';
import Span from '../../typography/Span';
import { ApolloError } from 'apollo-client';
import { SelectObject } from '../../utils/types';

const STATUS_OPTIONS: SelectObject[] = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Archived', value: 'ARCHIVED' },
  { label: 'Draft', value: 'DRAFT' },

];

const ContactUsValidation = Yup.object().shape({
  name: Yup.string().required('Required'),
  number: Yup.string(),
  email: Yup.string().email('Invalid email'),
  status: Yup.mixed().required('Required'),
});

type ContactUsFormValues = {
  name: string;
  number?: string;
  email?: string;
  status?: SelectObject;
};

interface Props {
  mutation: (values: any) => Promise<any>;
  error?: ApolloError;
  loading: boolean;
  initialValues?: ContactUsFormValues;
  formType: 'create' | 'edit';
  isNewPost?: boolean;
}

const ContactUsForm: React.FC<Props> = ({ initialValues, error, loading, mutation, formType }) => {
  return (
    <Formik
      validationSchema={ContactUsValidation}
      enableReinitialize={true}
      initialValues={
        initialValues || {
          name: '',
          number: '',
          email: '',
          status: formType === 'create' ? STATUS_OPTIONS.find(o => o.value === 'ACTIVE') : undefined,
        }
      }
      onSubmit={(values: ContactUsFormValues) => {
        mutation(values);
      }}
      render={(formikProps: FormikProps<ContactUsFormValues>): any => (
        <StyledForm width="100%" maxWidth="800px" mx="auto">
          <Card
            flex={1}
            bg="white"
            p={5}
            minWidth="500px"
            minHeight="500px"
            display="flex"
            flexDirection="column"
            justifyContent="center"
          >
            <FieldRow>
              <Field
                name="name"
                render={({ field }: FieldProps<ContactUsFormValues>): any => (
                  <StyledFormGroup {...field} field={field} form={formikProps} label="Name" style={{ width: '100%' }} />
                )}
              />
            </FieldRow>
            <FieldRow>
              <Field
                name="number"
                render={({ field }: FieldProps<ContactUsFormValues>): any => (
                  <StyledFormGroup
                    {...field}
                    field={field}
                    form={formikProps}
                    label="Telephone"
                    style={{ width: '100%' }}
                  />
                )}
              />
            </FieldRow>
            <FieldRow>
              <Field
                name="email"
                render={({ field }: FieldProps<ContactUsFormValues>): any => (
                  <StyledFormGroup
                    {...field}
                    field={field}
                    form={formikProps}
                    label="Email"
                    style={{ width: '100%' }}
                  />
                )}
              />
            </FieldRow>
            <FieldRow>
              <Field
                name="status"
                render={({ field }: FieldProps<ContactUsFormValues>): any => (
                  <StyledFormSelect
                    {...field}
                    field={field}
                    form={formikProps}
                    label="Status"
                    options={STATUS_OPTIONS}
                    style={{ width: '100%' }}
                  />
                )}
              />
            </FieldRow>
            {error && (
              <Span width="100%" textAlign="center" color="error" mb={3}>
                {formatGqlError(error)}
              </Span>
            )}
            <Button type="submit" text="SAVE" isLoading={loading} />
          </Card>
        </StyledForm>
      )}
    />
  );
};

export default ContactUsForm;



// WEBPACK FOOTER //
// ./src/forms/contactUs/ContactUsForm.tsx